import { Box, CloseIcon, Flex, FormTimeValueInput, IconButton, Text } from '@shared/components';

export interface FormExamDurationSessionTimeInputProps {
  order: number;
  name: string;
  onRemove?: () => void;
}

export default function FormExamDurationSessionTimeInput(
  props: Readonly<FormExamDurationSessionTimeInputProps>,
) {
  const { order, name, onRemove } = props;
  return (
    <Flex
      sx={(theme) => ({
        position: 'relative',
        alignItems: 'start',
        p: theme.spacing(4),
        gap: theme.spacing(6),
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.rounded(1.5),
        backgroundColor: theme.palette.grey[50],
      })}
    >
      <Text variant='body1Semibold'>ช่วงที่ {order}</Text>
      <Box sx={{ width: '240px' }}>
        <FormTimeValueInput name={name} label='ระยะเวลาสอบ (HH:MM)' unit='seconds' required />
      </Box>
      {onRemove ? (
        <IconButton
          onClick={onRemove}
          sx={(theme) => ({ position: 'absolute', top: theme.spacing(2), right: theme.spacing(2) })}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </Flex>
  );
}
